/* V11.3: Third-party script delay helpers + lazy sections */
/*! EVIV V11 Base JS */
document.addEventListener('DOMContentLoaded', () => {
  const lazy = document.querySelectorAll('[data-v11-section]');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        e.target.classList.add('v11-visible');
        io.unobserve(e.target);
      });
    }, { rootMargin: '300px' });
    lazy.forEach(el => io.observe(el));
  }
});
